export const HEADER_HEIGHT = 68;
export const HEADER_LINE_HEIGHT = 40;
export const HEADER_BOTTOM_MARGIN = 2;
export const HEADER_BOTTOM_PADDING = 30;
export const LEFT_PANEL_RIGHT_MARGIN = 2;
export const SCHEDULE_ITEM_HEIGHT = 90;
export const SCHEDULE_ITEM_LINE_HEIGHT = 84;
export const SCHEDULE_ITEM_ICON_LINE_HEIGHT = 45;
export const SCHEDULE_ITEM_RIGHT_MARGIN = 3;
export const SCHEDULE_ITEM_BOTTOM_MARGIN = 3;
export const TIMEMARK_WIDTH = 361;
export const TIMEMARK_LENGTH_IN_MINUTES = 30;
export const TIMEMARK_MAX_OFFSET = 400;
export const CATEGORY_HEIGHT = 94;
export const LIST_ITEM_COUNT = 15;
export const LOCK_SELECTED_AT_INDEX = 0;
export const DEFAULT_FIRST_SELECTED_INDEX = 1;
export const HOURS_OF_CONTENT_TO_LOAD = 4;
export const LOAD_MORE_CONTENT_LASTING_MINUTES_TO_END = 120;
export const LEFT_PANEL_WIDTH = 230;
export const LEFT_PANEL_NUMBER_WIDTH = 50;
export const LEFT_PANEL_LOGO_WIDTH = 180;
export const CHANNEL_HEIGHT = 50;

export const TIMEMARK_WIDTH_MOBILE = 172;
export const HEADER_HEIGHT_MOBILE = 40;
export const HEADER_LINE_HEIGHT_MOBILE = 4;
export const LEFT_PANEL_WIDTH_MOBILE = 152; // +
export const LEFT_PANEL_NUMBER_WIDTH_MOBILE = 40; // +
export const LEFT_PANEL_LOGO_WIDTH_MOBILE = 112; // +
export const CATEGORY_HEIGHT_MOBILE = 64;
export const SCHEDULE_ITEM_HEIGHT_MOBILE = 80;

export const GUIDE_ITEM_EMPTY = 'EMPTY';
export const GUIDE_ITEM_FOOTER = 'FOOTER';
